import Vue from 'vue';
import ApiUrl from '../apiurl';

export default {
    namespaced: true,
    state: {
        //装备安装率
        installedRatioList: [],
        //装车率
        einbaurateList: [],
        //装备参数列表
        equipParamsList: null,

        pk1List: [],
        pva: null,
        equipParamsByModel: null
    },
    getters: {

        installedRatioList: (state) => {
            return state.installedRatioList;
        },
        einbaurateList: (state) => {
            return state.einbaurateList;
        },
        pva: (state) => { return state.pva; },
        equipParamsList: (state) => {
            return state.equipParamsList;
        },
        pk1List: (state) => { return state.pk1List },
        equipParamsByModel: (state) => { return state.equipParamsByModel },
    },
    mutations: {

        setInstalledRatioList(state, newValue) {
            if (Array.isArray(newValue)) {
                Vue.set(state, 'installedRatioList', [...newValue]);
            }
        },
        setEinbaurateList(state, newValue) {
            if (Array.isArray(newValue)) {
                Vue.set(state, 'einbaurateList', [...newValue]);
            }
        },
        setEquipParamsList(state, newValue) {
            Vue.set(state, 'equipParamsList', newValue);
        },
        setPK1List(state, newValue) {
            Vue.set(state, 'pk1List', [...newValue]);
        },
        setEquipParamsByModel(state, newValue) {
            Vue.set(state, 'equipParamsByModel', newValue);
        },
        setPVA(state, newValue) {
            // alert(JSON.stringify(newValue));
            Vue.set(state, 'pva', newValue);
        },
    },
    actions: {


        async queryPVAGroup({ commit, state }, { params, handle }) {
            try {
                commit('startLoading', null, { root: true });
                const rsp = await axios.post(ApiUrl.equip.querypvagroup, params);
                var list = rsp.data.result;
                commit('setPVA', list);
                handle && handle(true);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }
        },
        async queryPVA({ commit, state }, { params, handle }) {
            try {
                commit('startLoading', null, { root: true });
                console.log("url", ApiUrl.equip.Querypva);
                const rsp = await axios.post(ApiUrl.equip.Querypva, params);
                console.log(rsp);
                var list = rsp.data.result;
                commit('setPVA', list);
                handle && handle(true);
            } catch (e) {
                console.log('error');
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }
        },
        /* 获取PK 数据 */
        async queryPk1({ commit, state }, { params, handle }) {
            try {
                commit('startLoading', null, { root: true });
                const rsp = await axios.post(ApiUrl.equip.queryPk1, params);
                var list = rsp.data.result;
                commit('setPK1List', list);
                handle && handle(true);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }
        },
        /*获取装备安装率*/
        async queryInstalledRatios({ commit, state }, { params, handle }) {
            try {
                commit('startLoading', null, { root: true });
                const rsp = await axios.post(ApiUrl.depth.installedRatios, params);
                var list = rsp.data.result;
                commit('setInstalledRatioList', list);
                handle && handle(true);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }
        },
        async queryEinbaurate({ commit, state }, { params, handle }) {
            try {
                commit('startLoading', null, { root: true });
                const rsp = await axios.post(ApiUrl.equip.queryeinbaurate, params);
                var list = rsp.data.result;
                commit('setEinbaurateList', list);
                handle && handle(true);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }
        },
        async queryEquipParams({ commit, state }, { params, handle }) {
            try {
                commit('startLoading', null, { root: true });
                const rsp = await axios.post(ApiUrl.equip.queryequipparams, params);
                var list = rsp.data.result;

                commit('setEquipParamsList', list);
                handle && handle(true);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }
        },
        async queryEquipParamsByModel({ commit, state }, { params, handle }) {
            try {
                commit('startLoading', null, { root: true });
                const rsp = await axios.post(ApiUrl.equip.equipparamsbymodel, params);
                var list = rsp.data.result;

                commit('setEquipParamsByModel', list);
                handle && handle(true);
            } catch (e) {
                console.error(e);
            } finally {
                commit('stopLoading', null, { root: true });
            }
        },
    },
}